module.exports = __webpack_public_path__ + "img/hedge_icon.1bbbabaf.png";